import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_bin_reservation_gen_doc_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_line_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_code: fromDatatype.VarcharDatatypeInterface;
  bin_line_code: fromDatatype.VarcharDatatypeInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  inv_item_name: fromDatatype.VarcharDatatypeInterface;
  entity_guid: fromDatatype.GuidDataFieldInterface;
  reservation_remarks: fromDatatype.VarcharDatatypeInterface;
  reservation_type: fromDatatype.VarcharDatatypeInterface;
  reservation_start_time: fromDatatype.TimestampTzDatatypeInterface;
  reservation_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  reserved_qty: fromDatatype.NumericDatatypeInterface;
  reserved_container_qty: fromDatatype.NumericDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  reserved_by_pic: fromDatatype.GuidDataFieldInterface;
  stock_reservation_hdr_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  posting_status: fromDatatype.StatusDataFieldInterface;
}

export class bl_inv_bin_reservation_gen_doc_link_RowClass implements
  bl_inv_bin_reservation_gen_doc_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bin_line_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_guid: fromDatatype.GuidDataFieldInterface;
  bin_hdr_code: fromDatatype.VarcharDatatypeInterface;
  bin_line_code: fromDatatype.VarcharDatatypeInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  inv_item_name: fromDatatype.VarcharDatatypeInterface;
  entity_guid: fromDatatype.GuidDataFieldInterface;
  reservation_remarks: fromDatatype.VarcharDatatypeInterface;
  reservation_type: fromDatatype.VarcharDatatypeInterface;
  reservation_start_time: fromDatatype.TimestampTzDatatypeInterface;
  reservation_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  reserved_qty: fromDatatype.NumericDatatypeInterface;
  reserved_container_qty: fromDatatype.NumericDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  reserved_by_pic: fromDatatype.GuidDataFieldInterface;
  stock_reservation_hdr_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  posting_status: fromDatatype.StatusDataFieldInterface;
}
